<template>
        <GanttElastic :options="options" :tasks="tasks" class="flex">

        </GanttElastic>
</template>
<script>
import dayjs from 'dayjs'
import {GanttElastic} from 'gantt-elastic-wrapvue3'
import 'gantt-elastic-wrapvue3/dist/style.css'
import MultiSelectInput from '@/Shared/MultiSelectInput'

export default {
    components: {
        GanttElastic,
        MultiSelectInput
    },
    props:{
        tasks:Array
    },
    data() {
        return {
        }
    },
    methods: {
        getDate(hours) {
            const currentDate = new Date()
            const currentYear = currentDate.getFullYear()
            const currentMonth = currentDate.getMonth() + 1
            const currentDay = currentDate.getDate()
            const timeStamp = new Date(`${currentYear}-${currentMonth}-${currentDay} 00:00:00`).getTime()
            return new Date(timeStamp + hours * 60 * 60 * 1000).getTime()

        },
    },
    mounted() {
        console.log('here gantt chart is mounted')
        console.log(this.tasks)
    },

}
</script>
<style>
.gantt-elastic__main-view {
    overflow: hidden;
}
</style>
